export function isSet(value) {
  return value !== undefined && value !== null;
}